import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useHistory } from "react-router-dom";
import { Routes } from "constants/routes";
import { useCheckUserSubscriptionOnMount } from "hooks/Checkout";
import LoaderCentered from "app/components/Loader/LoaderCentered";
import { useIntroOfferCoupon } from "hooks/Checkout/useIntroOfferCoupon";
import { formatCentsAsCurrency } from "helpers/currency";
import styles from "./styles.module.scss";
import { LogoNav } from "../Checkout/LogoNav";

export default function IntroOffer() {
  const history = useHistory();
  const {
    isEligibleForIntroOffer,
    standardYearlyPlan,
    introOfferCouponId,
    couponEstimate,
    isLoadingIntroOffer,
  } = useIntroOfferCoupon();

  useEffect(() => {
    if (isLoadingIntroOffer) {
      return;
    }

    if (!isEligibleForIntroOffer) {
      history.push(Routes.dashboard);
    }
  }, [isEligibleForIntroOffer, history, isLoadingIntroOffer]);

  useCheckUserSubscriptionOnMount();

  if (isLoadingIntroOffer) {
    return <LoaderCentered />;
  }

  if (!standardYearlyPlan) {
    return <LoaderCentered />;
  }

  const handleClaimOffer = () => {
    history.push(`${Routes.checkout}?coupon=${introOfferCouponId}`);
  };

  return (
    <div className={styles.container}>
      <Helmet title="Special Intro Offer | STEEZY Studio" />
      <LogoNav />

      <div className={styles.content}>
        <h1 className={styles.title}>Get 50% off today</h1>
        <p className={styles.subtitle}>
          Get 1 year of STEEZY at a discount when you purchase today
        </p>
        <p className={styles.price}>
          {formatCentsAsCurrency(
            couponEstimate.discountPlanPriceInCents,
            standardYearlyPlan.currencyCode
          )}{" "}
          for the first year, then{" "}
          {formatCentsAsCurrency(
            standardYearlyPlan.priceInCents,
            standardYearlyPlan.currencyCode
          )}{" "}
          annually
        </p>
        <button
          className={styles.claimButton}
          onClick={handleClaimOffer}
          type="button"
        >
          CLAIM MY OFFER
        </button>
        <p className={styles.disclaimer}>Offer eligible for new users only</p>
      </div>
    </div>
  );
}
